import { isSafeRedirectPath } from '@/features/authorization/hooks/useAuthComplete'
import { useLocation } from 'react-router-dom'

export const useMissionRedirect = () => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const raw = params.get('redirect')
  const redirect = raw && isSafeRedirectPath(raw) ? raw : null

  const withRedirectToCurrent = (targetPath: string): string => {
    const returnTo = `${location.pathname}${location.search}`
    const [basePath, existingQuery = ''] = targetPath.split('?')
    const sp = new URLSearchParams(existingQuery)
    sp.set('redirect', returnTo)
    return `${basePath}?${sp.toString()}`
  }

  return { redirect, withRedirectToCurrent }
}
